import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    options: Object,
  };

  disconnect() {
    if (this.chart !== undefined) {
      this.chart.dispose();
      this.chart = null;
    }
  }

  FwaAssessmentUsageChart = () => {
    this.chart = window.echarts.init(document.getElementById('fwa-assessment-usage-chart'));
    this.chart.setOption(this.optionsValue);
  };

  whenEchartsAvailable = () => {
    const interval = setInterval(() => {
      if (window.echarts !== undefined) {
        this.FwaAssessmentUsageChart();
        window.onresize = () => {
          if (this.chart !== null) {
            this.chart.resize();
          }
        };
        clearInterval(interval);
      }
    }, 10);
  };

  initialize() {
    this.whenEchartsAvailable();
  }
}
